import { useFormContext } from "react-hook-form";
import Checkbox from "@/components/Checkbox/Checkbox";
import { useLingui } from "@lingui/react/macro";

export type LifeCareCheckboxFields = {
  lifeCare: boolean;
};

const LifeCareCheckbox = () => {
  const { register } = useFormContext<LifeCareCheckboxFields>();
  const { t } = useLingui();

  return <Checkbox label={{ text: t`LifeCare` }} {...register("lifeCare")} />;
};

export default LifeCareCheckbox;
